export default __webpack_public_path__ + "static/media/search.0230f5c5.svg";